import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes';
import reportWebVitals from './reportWebVitals';
import GlobalStyle from './styles/normalize';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle/>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
